export const Seo = ({ title, description, path = "" }) => {
  const full = title ? `${title} | The Catalyst` : "The Catalyst | Marketing Agency Canberra";
  const url = typeof window !== "undefined" ? `${window.location.origin}${path}` : path;
  return (
    <>
      <title>{full}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={full} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
    </>
  );
};
